import React, { createContext, useCallback, useContext, useState } from "react";

export const MinuteListContext = createContext({});

export const MinuteListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      requester: undefined,
      minuteStatus: [],
      companies: [],
      committees: [],
      startDate: null,
      endDate: null,
      keyword: undefined,
    },
    pagination: {
      page: 0,
      size: 20,
    },
  });
  const [expandedMinuteIds, setExpandedMinuteIds] = useState([]);

  const updateFilterParams = useCallback((params) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      filterParams: params,
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      pagination: paginationOption,
    }));
  }, []);

  return (
    <MinuteListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination, expandedMinuteIds, setExpandedMinuteIds }}
    >
      {children}
    </MinuteListContext.Provider>
  );
};

export function useMinuteList() {
  const context = useContext(MinuteListContext);

  if (!context) {
    throw new Error("useMinuteList must be used within an MinuteListProvider.");
  }

  return context;
}
